import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isCdiSegmentsConfig = objectOf({
  id: string,
  name: string,
  partner_name: string,
  security_config: objectOf({
    id: string,
  }),
});
